<template>
  <div
    class="tm-breadcrumbs-wrapper"
    :class="{
      'tm-breadcrumbs-wrapper_padding': !withoutPadding,
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  withoutPadding?: boolean
}>()
</script>

<style lang="scss" scoped>
@import '@/styles/mixins';

.tm-breadcrumbs-wrapper {
  &_padding {
    padding: 6px 0;
  }
  max-width: 100%;
  flex-grow: 1;

  @include overflow-hidden-with-clip-margin;
}
</style>
